module.exports = __webpack_public_path__ + "img/li.347aec79.svg";